import React from 'react'
import ReactDOM from 'react-dom'
import {App} from './app'

const loader = document.querySelector('.loader')

const hideLoader = () => loader && loader.classList.add('loader--hide')

ReactDOM.render(<App hideLoader={hideLoader} />, document.getElementById('root'))
